export default __webpack_public_path__ + "static/media/photoWithText.948d0f0e.png";